module.exports = __webpack_public_path__ + "static/img/500.c6b4caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/images/error/500.png
// module id = D6RS
// module chunks = 1